<template>
  <div class="news">
    <div class="title">
      <h1>标题标题标题标题标题</h1>
      <div class="time">2021-11-11&nbsp;17:00</div>
    </div>
    <div class="content">
      新闻正文内容新闻正文内容新闻正文内容新闻正文内容新闻正文内容新闻正文内容新闻正文内容新闻正文内容新闻正文内容新闻正文内容新闻正文内容新闻正文内容新闻正文内容新闻正文内容新闻正文内容新闻正文内容新闻正文内容新闻正文内容新闻正文内容新闻正文内容新闻正文内容新闻正文内容新闻正文内容新闻正文内容新闻正文内容新闻正文内容新闻正文内容新闻正文内容新闻正文内容新闻正文内容新闻正文内容新闻正文内容新闻正文内容新闻正文内容新闻正文内容新闻正文内容新闻正文内容新闻正文内容新闻正文内容新闻正文内容新闻正文内容新闻正文内容新闻正文内容新闻正文内容新闻正文内容新闻正文内容新闻正文内容新闻正文内容新闻正文内容新闻正文内容新闻正文内容新闻正文内容新闻正文内容新闻正文内容新闻正文内容新闻正文内容新闻正文内容新闻正文内容新闻正文内容新闻正文内容新闻正文内容新闻正文内容新闻正文内容新闻正文内容新闻正文内容新闻正文内容新闻正文内容新闻正文内容新闻正文内容新闻正文内容新闻正文内容新闻正文内容新闻正文内容新闻正文内容新闻正文内容新闻正文内容新闻正文内容新闻正文内容新闻正文内容新闻正文内容新闻正文内容新闻正文内容新闻正文内容新闻正文内容新闻正文内容新闻正文内容新闻正文内容新闻正文内容新闻正文内容新闻正文内容新闻正文内容新闻正文内容新闻正文内容新闻正文内容新闻正文内容新闻正文内容新闻正文内容新闻正文内容新闻正文内容新闻正文内容新闻正文内容新闻正文内容新闻正文内容新闻正文内容新闻正文内容新闻正文内容新闻正文内容新闻正文内容新闻正文内容新闻正文内容新闻正文内容新闻正文内容新闻正文内容新闻正文内容新闻正文内容新闻正文内容新闻正文内容新闻正文内
      容
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style  scoped>
.news {
  margin: 0 150px;
  padding-top: 80px;
}
.title {
  width: 100%;
  text-align: center;
  border-bottom: 1px solid #979797;
}
.title > h1 {
  font-size: 18px;
  margin-top: 80px;
  margin-bottom: 10px;
}
.time {
  color: #7e7e7c;
  margin-bottom: 10px;
  font-size: 12px;
}
.content {
  margin-top: 10px;
  font-size: 14px;
  color: #7e7e7c;
  line-height: 30px;
}
</style>>
    
</style>